enum MemberRoleTypes {
  Owner = 'owner',
  Collaborator = 'collaborator',
  Guest = 'guest',
  GuestWithFinancials = 'guest_with_financials',
  Client = 'client',
}

export { MemberRoleTypes }
